<template>
  <!-- <div> -->
  <v-row justify="center">
    <v-dialog v-model="dialog" max-width="600px">
      <template v-slot:activator="{ on }">
        <v-btn
          @click.stop="dialog = true"
          large
          text
          outlined
          rounded
          class="ma-3"
          color="green"
          style="background-color: black"
        >ADD INITIAL DOCUMENTS</v-btn>
      </template>
      <v-card
        flat
        outlined
        style="background-color: black;border-radius: 26px; border: 3px solid #a07800"
      >
        <v-card-title>
          <span class="headline">ADD INITIAL DOCUMENTS</span>
        </v-card-title>
        <v-form class="ma-2 pa-2" @submit.prevent="onAddInitialDocs" ref="form">
          <div>
            <v-card
              style="background-color: black; border-radius: 26px; max-width: 500px; border: 1px solid #a07800"
              outlined
              tile
              rounded
              class="ma-auto"
              dense
            >
              <div class="ma-2 mt-2">
                <v-file-input
                  class="ma-2 mt-6"
                  autofocus
                  outlined
                  chips
                  multiple
                  label="Upload Initial Documents"
                  ref="fileInput"
                  @change="onFilePicked"
                  dense
                  color="#a07800"
                ></v-file-input>
              </div>
              <v-card>
                <ol class="ma-auto">
                  <li v-for="(file, index) in initialDocs" :key="index">
                    <v-layout>
                      <div class="ma-auto">{{ file.name }}</div>
                      <v-btn small text rounded @click="removeFile(index)">
                        <v-icon color="red">mdi-minus-circle</v-icon>
                      </v-btn>
                    </v-layout>
                  </li>
                </ol>
              </v-card>
            </v-card>
          </div>
          <v-layout row class="mt-2">
            <v-spacer></v-spacer>
            <v-btn rounded text outlined @click="cancelDialog">CANCEL</v-btn>
            <v-spacer></v-spacer>
            <v-btn rounded color="black" :disabled="!formIsValid" dark type="submit">SUBMIT</v-btn>
            <v-spacer></v-spacer>
          </v-layout>
        </v-form>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
/**
 * this component simply allows the user to upload initial documents for the matter,
 * it saves the documents to storage and saves a download link in the matter document
 * in the database.
 */
export default {
  props: ["matter"],
  data() {
    return {
      initialDocs: [],
      dialog: false,
    };
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    // matter() {
    //   return this.$store.getters.;
    // },
    formIsValid() {
      return this.initialDocs !== null;
    },
  },
  methods: {
    onFilePicked() {
      if (event.target.files) {
        const fileList = Array.from(event.target.files);
        fileList.forEach((file) => {
          this.initialDocs.push(file);
        });
      }
    },

    removeFile(index) {
      this.initialDocs.splice(index, 1);
    },

    onAddInitialDocs() {
      if (this.formIsValid) {
        let payload = {
          initialDocs: this.initialDocs,
          matterSlug: this.matter.matterSlug,
          firmSlug: this.user.firmSlug,
        };
        console.log("going to addinitdocs from component", payload);
        this.$store.dispatch("addInitialDocs", payload);
        this.initialDocs = [];
        this.dialog = false;
      }
    },
    cancelDialog() {
      this.initialDocs = [];
      this.dialog = false;
    },
  },
};
</script>

<style lang="scss" scoped></style>
